// Mirrors internal/store/handles.go (SupportedCountries / DefaultsFor).
export const countries: { code: string; currency: string; locales: string[]; en: string; ar: string }[] = [
  { code: "QA", currency: "QAR", locales: ["en", "ar"], en: "Qatar", ar: "قطر" },
  { code: "AE", currency: "AED", locales: ["en", "ar"], en: "United Arab Emirates", ar: "الإمارات" },
  { code: "SA", currency: "SAR", locales: ["en", "ar"], en: "Saudi Arabia", ar: "السعودية" },
  { code: "KW", currency: "KWD", locales: ["en", "ar"], en: "Kuwait", ar: "الكويت" },
  { code: "BH", currency: "BHD", locales: ["en", "ar"], en: "Bahrain", ar: "البحرين" },
  { code: "OM", currency: "OMR", locales: ["en", "ar"], en: "Oman", ar: "عُمان" },
  { code: "JO", currency: "JOD", locales: ["en", "ar"], en: "Jordan", ar: "الأردن" },
  { code: "EG", currency: "EGP", locales: ["en", "ar"], en: "Egypt", ar: "مصر" },
  { code: "US", currency: "USD", locales: ["en"], en: "United States", ar: "الولايات المتحدة" },
  { code: "GB", currency: "GBP", locales: ["en"], en: "United Kingdom", ar: "المملكة المتحدة" },
];
export const currencies = ["QAR", "AED", "SAR", "KWD", "BHD", "OMR", "JOD", "EGP", "USD", "GBP", "EUR"];

// countryName: the country in the admin's language (any language the
// browser knows), the English name otherwise.
export function countryName(c: { code: string; en: string; ar: string }, locale: string): string {
  if (locale === "ar") return c.ar;
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(c.code) ?? c.en;
  } catch {
    return c.en;
  }
}

// languageName: a language in itself ("Français", "العربية").
export function languageName(code: string): string {
  try {
    return new Intl.DisplayNames([code], { type: "language" }).of(code) ?? code;
  } catch {
    return code;
  }
}
